import { SIZE_36, SIZE_40, SIZE_44, SIZE_48, ONLY_ICONS_SIZE_CONFIG, DEFAULT_SIZE_CONFIG, } from './constants';
const buildDefaultBtnStylesFromSize = ({ p, borderRadius, minWidth, }) => `
  padding: ${p};
  border-radius: ${borderRadius};
  min-width: ${minWidth};
`;
const { BTN_SIZE_36, BTN_SIZE_40, BTN_SIZE_44, BTN_SIZE_48 } = DEFAULT_SIZE_CONFIG;
const { ONLY_ICON_BTN_SIZE_36, ONLY_ICON_BTN_SIZE_40, ONLY_ICON_BTN_SIZE_44, ONLY_ICON_BTN_SIZE_48, } = ONLY_ICONS_SIZE_CONFIG;
export function getStylesButtonBySize({ size = SIZE_36 }) {
    const options = {
        [SIZE_36]: buildDefaultBtnStylesFromSize(BTN_SIZE_36),
        [SIZE_40]: buildDefaultBtnStylesFromSize(BTN_SIZE_40),
        [SIZE_44]: buildDefaultBtnStylesFromSize(BTN_SIZE_44),
        [SIZE_48]: buildDefaultBtnStylesFromSize(BTN_SIZE_48),
    };
    return options[size];
}
const buildOnlyIconBtnStylesFromSize = ({ p, borderRadius, widthHeight, }) => `
  padding: ${p};
  border-radius: ${borderRadius};
  width: ${widthHeight};
  height: ${widthHeight};
`;
export function getStylesOnlyIconButtonBySize({ size = SIZE_36 }) {
    const options = {
        [SIZE_36]: buildOnlyIconBtnStylesFromSize(ONLY_ICON_BTN_SIZE_36),
        [SIZE_40]: buildOnlyIconBtnStylesFromSize(ONLY_ICON_BTN_SIZE_40),
        [SIZE_44]: buildOnlyIconBtnStylesFromSize(ONLY_ICON_BTN_SIZE_44),
        [SIZE_48]: buildOnlyIconBtnStylesFromSize(ONLY_ICON_BTN_SIZE_48),
    };
    return options[size];
}
